import request from '@/services/interceptor.js'

// Utente
export const get_datiUserInfo = () => {
    return request({
        url: '/user/info',
        method: 'get',
        loadingBar: true
    })
};

export const save_userAccount = (par) => {
    return request({
        url: '/user/account/save',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const salva_spunta_privacy = () => {
    return request({
        url: '/user/account/privacy',
        method: 'get',
        loadingBar: false
    })
}